import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { config } from "../../../../../../../config";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import "./Divisions.css";
import WarningDialogue from '../../../../../../../Util/WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function Divisions(props) {

  const [leagueId, setLeagueId] = useState(0);
  const [division, setDivision] = useState([]);
  const [teams, setTeams] = useState([]);
  const [requestComplete, setRequestComplete] = useState(false);
  const [isDragDisabled, setIsDragDisabled] = useState(true);
  const [leagueSeason, setLeagueSeason] = useState(null);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});

  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    getLeagueInfo();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getDivision();
      getLeagueInfo();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const getDivision = () => {
    setRequestComplete(false);
    axiosApi.get(`${config.apiUrl}/leagues/schedule/division/${leagueId}`)
      .then((response) => {
        setRequestComplete(true);
        if (response.data.data) {
          let divisionData = []
          response.data.data.forEach(element => {
            element.team_ids = element.team_ids.split(',');
            divisionData = [...divisionData, ...[element]]
          });
          if (divisionData.length) {
            const leagueInfo = divisionData[0].league;
            if (leagueInfo && ['sign_up', 'need_schedule'].includes(leagueInfo.status)) {
              setIsDragDisabled(false);
            }
          }
          setDivision(divisionData);
        }
        setTeams(response.data.teamData);
      }, err => {
        setRequestComplete(true)
      })
  }

  const modifyDivision = () => {
    if (!isDragDisabled) {
      const divisions = [...division].map(x => ({ ...x, team_ids: x.team_ids.toString() }));
      axiosApi.post(`${config.apiUrl}/leagues/schedule/division`, { league_id: leagueId, divisions });
    }
  }

  const recreateDivision = () => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Confirm',
      description: 'Would you like to re-create division ?',
      icon: faExclamationTriangle,
      action: () => {
        axiosApi.get(`${config.apiUrl}/misc/generate-division/${leagueId}`).then(() => {
          getDivision();
          setOpenWarningPopup(false);
        }).catch(() => {

        });
      }
    });
  }

  const getLeagueInfo = () => {
    axiosApi.get(`${config.apiUrl}/misc/league/season/info/${leagueId}`).then((response) => {
      let data = response.data.data;
      setLeagueSeason(data);
    }).catch(() => {
    });
  }


  const teamName = (id) => {
    let name = '--';
    if (id && teams) {
      const findTeam = teams.find(x => +x.id === +id);
      if (findTeam) {
        name = `${findTeam.name} (${findTeam.preferred_time.charAt(0).toUpperCase()})`;
      }
    }
    return name;
  }

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };


  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    if (source.droppableId === destination.droppableId) {
      const mainIndex = source.droppableId.split('-')[1];
      const teamOrder = [...reorder(division[mainIndex].team_ids, source.index, destination.index)];
      division[mainIndex].team_ids = [...teamOrder];
      setDivision(division);
    } else {
      const sourceIndex = source.droppableId.split('-')[1];
      const destinationIndex = destination.droppableId.split('-')[1];
      const result = move(
        division[sourceIndex].team_ids,
        division[destinationIndex].team_ids,
        source,
        destination
      );
      division[sourceIndex].team_ids = [...result[source.droppableId]];
      division[destinationIndex].team_ids = [...result[destination.droppableId]];
      setDivision(division);
    }
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    // change background colour if dragging
    background: isDragging ? 'lightgrey' : '',

    // styles we need to apply on draggables
    ...draggableStyle
  });

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'transparent' : 'transparent',
  });

  return (
    <>
      <div className="divisions-wrapper">
        <h2 className="heading">Divisions</h2>
        {
          leagueSeason?.status && (leagueSeason?.status === 'need_schedule' || leagueSeason?.status === 'sign_up') && <button className="btn-primary" onClick={() => recreateDivision()}>Re-create Division</button>
        }

        {division?.length > 0 && !isDragDisabled && <button className="btn-primary" onClick={() => modifyDivision()}>Modify Division</button>}
        <DragDropContext onDragEnd={onDragEnd}>

          {
            division &&
            division.length > 0 &&
            division.map((dv, i) => (
              <Droppable droppableId={`droppable-${i}`} key={i}>
                {(provided, snapshot) => (
                  <div className="division-inner" ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}>
                    <h3>{dv.name}</h3>
                    {
                      dv.team_ids &&
                      <div className="inner-wrapper">
                        <ul>
                          {
                            dv.team_ids.map((team, index) => (
                              <Draggable
                                key={`${team}-${index}`}
                                draggableId={`${team.toString()}`}
                                index={index}
                                isDragDisabled={isDragDisabled}>
                                {(provided, snapshot) => (
                                  <li ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                    )}
                                    data-react-beautiful-dnd-draggable="0"
                                    data-react-beautiful-dnd-drag-handle="0">
                                    {teamName(team)}
                                  </li>
                                )}
                              </Draggable>
                            ))
                          }
                          {provided.placeholder}
                        </ul>
                      </div>
                    }
                  </div>
                )}
              </Droppable>
            ))
          }
        </DragDropContext>
        {
          !division.length &&
          requestComplete &&
          <div className="division-inner no-record">
            <h3>
              There are no divisions for the this league.
            </h3>
          </div>
        }

        <WarningDialogue
          isOpen={openWarningPopup}
          header={popUpContent.header}
          description={popUpContent.description}
          paymentWarning={popUpContent.payment}
          icon={popUpContent.icon}
          action={popUpContent.action}
          onClose={() => { setOpenWarningPopup(false); }}
        />
      </div>
    </>
  );
}

export default withRouter(Divisions);
